<template>
  <div class="clientContract">
    <div class="header">
      <div class="title">客户合同</div>
    </div>
    <van-form ref="form" @submit="handleSubmit">
      <van-field
        v-model="form.contractName"
        name="contractName"
        label="合同名称"
        placeholder="请输入合同名称"
        :rules="rules.contractName"
        :required="true"
      />
      <van-field
        readonly
        clickable
        name="applyType"
        :value="getTextByValue('apply_type_4045', form.applyType)"
        label="申请类型"
        placeholder="请选择申请类型"
        :rules="rules.applyType"
        :required="true"
        @click="showPicker('applyType')"
      />
      <van-popup v-model="pickers.applyTypeVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['apply_type_4045']"
          @confirm="option => onConfirm('applyType', option)"
          @cancel="closePicker('applyType')"
        />
      </van-popup>

      <van-field
        v-model="form.correlationContractNo"
        name="correlationContractNo"
        label="关联合同"
        placeholder="请输入关联合同"
      />

      <van-field
        v-model="form.partyA"
        name="partyA"
        label="协议甲方"
        placeholder="请输入协议甲方"
        :rules="rules.partyA"
        :required="true"
      />
      <van-field
        v-model="form.partyB"
        name="partyB"
        label="协议乙方"
        placeholder="请输入协议乙方"
        :rules="rules.partyB"
        :required="true"
      />
      <van-field
        v-model="form.partyC"
        name="partyC"
        label="协议丙方"
        placeholder="请输入协议丙方"
      />

      <van-field
        readonly
        clickable
        name="contractType"
        :value="getTextByValue('contract_type_4020', form.contractType)"
        label="合同类型"
        placeholder="请选择合同类型"
        :rules="rules.contractType"
        :required="true"
        @click="showPicker('contractType')"
      />
      <van-popup v-model="pickers.contractTypeVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['contract_type_4020']"
          @confirm="option => onConfirm('contractType', option)"
          @cancel="closePicker('contractType')"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="projectSource"
        :value="getTextByValue('project_source_4026', form.projectSource)"
        label="项目来源"
        placeholder="请选择项目来源"
        :rules="rules.projectSource"
        :required="true"
        @click="showPicker('projectSource')"
      />
      <van-popup v-model="pickers.projectSourceVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['project_source_4026']"
          @confirm="option => onConfirm('projectSource', option)"
          @cancel="closePicker('projectSource')"
        />
      </van-popup>

      <van-field
        v-model="form.projectManage"
        name="projectManage"
        label="PM"
        placeholder="请输入PM"
        :rules="rules.projectManage"
        :required="true"
      />

      <van-field
        readonly
        clickable
        name="incentiveType"
        :required="true"
        :value="
          getTextByValue('customer_incentive_type_2775', form.incentiveType)
        "
        label="激励类型"
        placeholder="请选择激励类型"
        @click="showPicker('incentiveType')"
      />
      <van-popup v-model="pickers.incentiveTypeVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['customer_incentive_type_2775']"
          @confirm="option => onConfirm('incentiveType', option)"
          @cancel="closePicker('incentiveType')"
        />
      </van-popup>

      <van-field
        :value="getTextByValue('sale_principal_1256', form.saleMain)"
        readonly
        clickable
        name="saleMain"
        label="客户销售组织"
        placeholder="请选择客户销售组织"
        :rules="rules.saleMain"
        :required="true"
        @click="showPicker('saleMain')"
      />
      <van-popup v-model="pickers.saleMainVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['sale_principal_1256']"
          @confirm="option => onConfirm('saleMain', option)"
          @cancel="closePicker('saleMain')"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="accPayType"
        :value="getTextByValue('acc_pay_type_4030', form.accPayType)"
        label="付款类型"
        placeholder="请选择付款类型"
        :rules="rules.accPayType"
        :required="true"
        @click="showPicker('accPayType')"
      />
      <van-popup v-model="pickers.accPayTypeVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['acc_pay_type_4030']"
          @confirm="option => onConfirm('accPayType', option)"
          @cancel="closePicker('accPayType')"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="accPayData"
        :value="getTextByValue('acc_pay_data_4034', form.accPayData)"
        label="结算周期"
        placeholder="请选择结算周期"
        :rules="rules.accPayData"
        :required="true"
        @click="showPicker('accPayData')"
      />
      <van-popup v-model="pickers.accPayDataVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['acc_pay_data_4034']"
          @confirm="option => onConfirm('accPayData', option)"
          @cancel="closePicker('accPayData')"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="invoiceType"
        label="发票类型"
        placeholder="请选择发票类型"
        :rules="rules.invoiceType"
        :required="true"
        :value="getTextByValue('contract_invoice_type_4083', form.invoiceType)"
        @click="showPicker('invoiceType')"
      />
      <van-popup v-model="pickers.invoiceTypeVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['contract_invoice_type_4083']"
          @confirm="option => onConfirm('invoiceType', option)"
          @cancel="closePicker('invoiceType')"
        />
      </van-popup>

      <van-field
        v-model="form.customerPhone"
        name="customerPhone"
        :required="true"
        label="对接人联系电话"
        placeholder="请输入对接人联系电话"
      />
      <van-field
        v-model="form.paidInCapital"
        name="paidInCapital"
        type="number"
        label="实缴资本"
        placeholder="请输入实缴资本"
        :rules="[
          {
            required: isCapitalAndInsuredRequired,
            message: '请输入实缴资本'
          }
        ]"
        :required="isCapitalAndInsuredRequired"
      />
      <van-field
        v-model="form.insuredCount"
        name="insuredCount"
        type="number"
        label="参保人数"
        placeholder="请输入参保人数"
        :rules="[
          {
            required: isCapitalAndInsuredRequired,
            message: '请输入参保人数'
          }
        ]"
        :required="isCapitalAndInsuredRequired"
      />
      <van-field
        v-model="form.cashDeposit"
        name="cashDeposit"
        type="number"
        label="押金/保证金"
        placeholder="请输入押金/保证金"
      />

      <van-field
        readonly
        clickable
        name="contractStartTime"
        :value="form.contractStartTime"
        label="合同开始时间"
        placeholder="请选择合同开始时间"
        :rules="rules.contractStartTime"
        :required="true"
        @click="showStartTimePicker = true"
      />
      <van-popup v-model="showStartTimePicker" position="bottom">
        <van-datetime-picker
          v-model="startTimeDate"
          type="date"
          @confirm="onConfirmStartTime"
          @cancel="showStartTimePicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="contractEndTime"
        :value="form.contractEndTime"
        label="合同结束时间"
        placeholder="请选择合同结束时间"
        :rules="rules.contractEndTime"
        :required="true"
        @click="showEndTimePicker = true"
      />
      <van-popup v-model="showEndTimePicker" position="bottom">
        <van-datetime-picker
          v-model="endTimeDate"
          type="date"
          @confirm="onConfirmEndTime"
          @cancel="showEndTimePicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="stampOrder"
        :value="getTextByValue('stamp_order_4041', form.stampOrder)"
        label="盖章顺序"
        placeholder="请选择盖章顺序"
        :rules="rules.stampOrder"
        :required="true"
        @click="showPicker('stampOrder')"
      />
      <van-popup v-model="pickers.stampOrderVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['stamp_order_4041']"
          @confirm="option => onConfirm('stampOrder', option)"
          @cancel="closePicker('stampOrder')"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="isRelatedParty"
        :value="getTextByValue('true_false_1212', form.isRelatedParty)"
        label="是否属于已合作客户的分子公司、关联公司(含实控关系)"
        placeholder="请认真、如实、严谨填报"
        :rules="rules.isRelatedParty"
        :required="true"
        @click="showPicker('isRelatedParty')"
      />
      <van-popup v-model="pickers.isRelatedPartyVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="dictionaryData['true_false_1212']"
          @confirm="option => onConfirm('isRelatedParty', option)"
          @cancel="closePicker('isRelatedParty')"
        />
      </van-popup>

      <van-field
        v-model="form.customerBackgroundDesc"
        name="customerBackgroundDesc"
        type="textarea"
        rows="3"
        autosize
        label="客户背景及采购用途说明（员工福利请提供链接，非自拓请详细说明客户来源）"
        placeholder="客户来源，客户与其下游协议或商城上架证明等"
        :rules="rules.customerBackgroundDesc"
        :required="true"
      />

      <van-field
        v-model="form.receiveInfo"
        name="receiveInfo"
        type="textarea"
        rows="3"
        autosize
        label="收件信息"
        placeholder="请输入收件信息"
        :rules="rules.receiveInfo"
        :required="true"
      />

      <van-field
        v-model="form.remark"
        name="remark"
        type="textarea"
        rows="3"
        autosize
        label="备注"
        placeholder="请输入备注"
      />

      <van-field
        name="fileList"
        label="合同附件"
        :rules="rules.fileList"
        :required="true"
      >
        <template #input>
          <van-uploader
            v-model="fileList"
            :after-read="file => handleAfterRead(file, 'fileList')"
            :before-delete="file => handleBeforeDelete(file, 'fileList')"
            accept="*"
            multiple
          />
        </template>
      </van-field>

      <van-field
        name="businessLicenseFileList"
        label="营业执照复印件"
        :rules="[
          {
            required: fileRequired,
            message: '请上传营业执照复印件,且不能超过10M'
          }
        ]"
        :required="fileRequired"
      >
        <template #input>
          <van-uploader
            v-model="businessLicenseFileList"
            :after-read="
              file => handleAfterRead(file, 'businessLicenseFileList')
            "
            :before-delete="
              file => handleBeforeDelete(file, 'businessLicenseFileList')
            "
            accept="*"
            multiple
          />
        </template>
      </van-field>

      <van-field
        name="legalPersonIdFileList"
        label="法人身份证正反面复印件"
        :rules="[
          {
            required: fileRequired,
            message: '请上传法人身份证正反面复印件,且不能超过10M'
          }
        ]"
        :required="fileRequired"
      >
        <template #input>
          <van-uploader
            v-model="legalPersonIdFileList"
            :after-read="file => handleAfterRead(file, 'legalPersonIdFileList')"
            :before-delete="
              file => handleBeforeDelete(file, 'legalPersonIdFileList')
            "
            accept="*"
            multiple
          />
        </template>
      </van-field>

      <van-field
        name="officePhotoFileList"
        label="办公场所及门头照片"
        :rules="[
          {
            required: fileRequired,
            message: '请上传办公场所及门头照片,且不能超过10M'
          }
        ]"
        :required="fileRequired"
      >
        <template #input>
          <van-uploader
            v-model="officePhotoFileList"
            :after-read="file => handleAfterRead(file, 'officePhotoFileList')"
            :before-delete="
              file => handleBeforeDelete(file, 'officePhotoFileList')
            "
            accept="*"
            multiple
          />
        </template>
      </van-field>

      <van-field
        v-model="form.createName"
        name="createName"
        label="提交人"
        placeholder="请输入提交人"
        :rules="rules.createName"
        :required="true"
      />

      <div class="submit-section">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          :loading="submitting"
          loading-text="提交中..."
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {
  getSystemDictionary,
  uploadFile,
  addRemote
  // getSignName
} from '@/api/clientContract'
import moment from 'moment'

export default {
  name: 'ClientContract',
  data() {
    return {
      form: {
        accPayData: undefined,
        accPayType: undefined,
        applyType: undefined,
        cashDeposit: undefined,
        contractEndTime: '',
        contractName: '',
        contractStartTime: '',
        contractType: undefined,
        correlationContractNo: '',
        createName: '',
        customerBackgroundDesc: '',
        fileList: [],
        incentiveType: undefined,
        invoiceType: null,
        partyA: '',
        partyB: '',
        partyC: '',
        projectManage: '',
        projectSource: undefined,
        receiveInfo: '',
        remark: '',
        saleMain: '',
        stampOrder: undefined,
        isRelatedParty: undefined,
        customerPhone: undefined,
        paidInCapital: undefined,
        insuredCount: undefined,
        businessLicenseFileList: [],
        legalPersonIdFileList: [],
        officePhotoFileList: []
      },
      fileList: [],
      businessLicenseFileList: [],
      legalPersonIdFileList: [],
      officePhotoFileList: [],
      submitting: false,
      showStartTimePicker: false,
      showEndTimePicker: false,
      startTimeDate: new Date(),
      endTimeDate: new Date(),
      dictionaryData: {},
      pickers: {
        contractTypeVisible: false,
        applyTypeVisible: false,
        projectSourceVisible: false,
        accPayTypeVisible: false,
        accPayDataVisible: false,
        stampOrderVisible: false,
        incentiveTypeVisible: false,
        saleMainVisible: false,
        invoiceTypeVisible: false,
        isRelatedPartyVisible: false
      },
      rules: {
        contractName: [{ required: true, message: '请输入合同名称' }],
        applyType: [{ required: true, message: '请选择申请类型' }],
        partyA: [{ required: true, message: '请输入协议甲方' }],
        partyB: [{ required: true, message: '请输入协议乙方' }],
        contractType: [{ required: true, message: '请选择合同类型' }],
        incentiveType: [{ required: true, message: '请选择激励类型' }],
        projectSource: [{ required: true, message: '请选择项目来源' }],
        projectManage: [{ required: true, message: '请输入PM' }],
        saleMain: [{ required: true, message: '请输入客户销售组织' }],
        accPayType: [{ required: true, message: '请选择付款类型' }],
        accPayData: [{ required: true, message: '请选择结算周期' }],
        contractStartTime: [{ required: true, message: '请选择合同开始时间' }],
        contractEndTime: [{ required: true, message: '请选择合同结束时间' }],
        stampOrder: [{ required: true, message: '请选择盖章顺序' }],
        isRelatedParty: [
          {
            required: true,
            message: '请选择是否属于已合作客户的分子公司、关联公司(含实控关系)'
          }
        ],
        customerBackgroundDesc: [
          {
            required: true,
            message:
              '请输入客户背景及采购用途说明（员工福利请提供链接，非自拓请详细说明客户来源）'
          }
        ],
        receiveInfo: [{ required: true, message: '请输入收件信息' }],
        invoiceTypeText: [{ required: true, message: '请输入发票类型' }],
        createName: [{ required: true, message: '请输入提交人' }],
        fileList: [{ required: true, message: '请上传合同附件,且不能超过10M' }]
      }
    }
  },
  computed: {
    fileRequired() {
      return (
        Number(this.form.contractType) === 2 &&
        (Number(this.form.insuredCount) === 0 ||
          Number(this.form.paidInCapital) === 0)
      )
    },
    isCapitalAndInsuredRequired() {
      return Number(this.form.contractType) === 2
    }
  },
  methods: {
    async getDictionary() {
      try {
        const { code, data } = await getSystemDictionary()
        // 客户销售组织
        // const { data: signData } = await getSignName()
        if (code === 0) {
          data.sale_principal_1256 = data.sale_principal_1256.filter(v => {
            return ![2, 3, 4, 5].includes(v.value)
          })
          this.dictionaryData = data
        }
      } catch (error) {
        console.error('获取字典数据失败', error)
      }
    },

    getTextByValue(dictionaryKey, value) {
      const data = this.dictionaryData[dictionaryKey] || []
      const option = data.find(item => item.value === value)
      return option ? option.text : ''
    },

    showPicker(pickerKey) {
      this.pickers[pickerKey + 'Visible'] = true
    },

    closePicker(pickerKey) {
      this.pickers[pickerKey + 'Visible'] = false
    },

    onConfirm(field, option) {
      // 主体编号的话要把主体名称带上
      if (field === 'saleMain') {
        this.form.saleMainName = option.text
      }
      // 项目来源默认PM
      if (field === 'projectSource') {
        if ([0, 3].includes(option.value)) {
          this.form.projectManage = '公司+'
        } else {
          this.form.projectManage = ''
        }
      }

      // 常规
      this.form[field] = option.value
      this.closePicker(field)
    },

    onConfirmStartTime(value) {
      this.form.contractStartTime = moment(value).format('YYYY-MM-DD')
      this.showStartTimePicker = false
    },

    onConfirmEndTime(value) {
      this.form.contractEndTime = moment(value).format('YYYY-MM-DD')
      this.showEndTimePicker = false
    },

    async handleAfterRead(file, fieldKey) {
      if (Array.isArray(file)) {
        for (const item of file) {
          await this.uploadFile(item, fieldKey)
        }
      } else {
        await this.uploadFile(file, fieldKey)
      }
    },

    async uploadFile(file, fieldKey) {
      try {
        file.status = 'uploading'
        file.message = '上传中...'
        const formData = new FormData()
        formData.append('multipartFile', file.file)
        const { code, data } = await uploadFile(formData)
        if (code === 0) {
          file.status = 'done'
          file.message = '上传成功'
          this.form[fieldKey].push({
            fileName: file.file.name,
            fileUrl: data.fileUrl || data
          })
        } else {
          file.status = 'failed'
          file.message = '上传失败'
        }
      } catch (error) {
        file.status = 'failed'
        file.message = '上传失败'
        console.error('上传失败', error)
      }
    },

    handleBeforeDelete(file, detail) {
      const index = detail.index
      this.form[detail.name].splice(index, 1)
      return true
    },

    async handleSubmit() {
      try {
        this.submitting = true
        const { code, message } = await addRemote(this.form)
        if (code === 0) {
          this.$toast.success('提交成功')
          this.$refs.form.resetValidation()
          this.resetForm()
        } else {
          this.$toast.fail(message || '提交失败')
        }
      } catch (error) {
        console.error('提交失败', error)
        this.$toast.fail(error?.data?.message || '提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    },

    resetForm() {
      // 保留响应性，使用 Object.assign
      Object.assign(this.form, {
        accPayData: undefined,
        accPayType: undefined,
        applyType: undefined,
        cashDeposit: undefined,
        contractEndTime: '',
        contractName: '',
        contractStartTime: '',
        contractType: undefined,
        correlationContractNo: '',
        createName: '',
        customerBackgroundDesc: '',
        fileList: [],
        incentiveType: undefined,
        invoiceType: null,
        partyA: '',
        partyB: '',
        partyC: '',
        projectManage: '',
        projectSource: undefined,
        receiveInfo: '',
        remark: '',
        saleMain: '',
        stampOrder: undefined,
        customerPhone: undefined,
        isRelatedParty: undefined,
        paidInCapital: undefined,
        insuredCount: undefined,
        businessLicenseFileList: [],
        legalPersonIdFileList: [],
        officePhotoFileList: []
      })
      this.fileList = []
      this.businessLicenseFileList = []
      this.legalPersonIdFileList = []
      this.officePhotoFileList = []
    }
  },
  created() {
    this.getDictionary()
  }
}
</script>

<style lang="less" scoped>
.clientContract {
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 80px;

  .header {
    background: #fff;
    padding: 16px;
    text-align: center;
    border-bottom: 1px solid #eee;

    .title {
      font-size: 18px;
      font-weight: 500;
      color: #323233;
    }
  }

  .submit-section {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 16px;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  }
}
</style>
